<script setup>
  import SpotHeaderActionListBase from "@/components/SpotHeaderActionListBase.vue";
  import Icon from "@/components/icons/Icon.vue";

  const showSettingsModal = defineModel('showSettingsModal', { required: true });
</script>

<template>  
  <SpotHeaderActionListBase>
    <template #default="{ classes }">
      <li :class="classes.item">
        <button
          @click="showSettingsModal = true"
          type="button"
          :class="classes.button"
        >
          <Icon name="gear" :class="classes.icon" />
          <span :class="classes.label">Settings</span>
        </button>
      </li>
    </template>
  </SpotHeaderActionListBase>
</template>